import { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Logout } from '@mui/icons-material';
import { Box } from '@mui/material';
import { Logo } from '../../components';
import { LogoutButton } from '../../modules/auth';

type Props = {
  children: ReactNode;
};

/**
 * Bare Layout Structure with two rows
 * first row is holding logo and logout button only
 * second row is rendering children
 * @param children
 * @constructor
 */
export const BareLayout = ({ children }: Props) => {
  const { user } = useAuth0();
  return (
    <Box component={'main'} display={'flex'} flexDirection={'column'}>
      <Box
        px={4}
        py={2}
        display={'flex'}
        flexDirection={'row'}
        gap={2}
        justifyContent={{
          xs: 'center',
          md: 'space-between',
        }}
        alignItems={'center'}
        flexWrap={'wrap'}
      >
        <Logo width={150} />
        {user ? <LogoutButton variant={'outlined'} color={'error'} startIcon={<Logout />} /> : null}
      </Box>

      <Box position={'relative'} pb={4}>
        {children}
      </Box>
    </Box>
  );
};
